import React from 'react';
import { Col, Form } from 'antd';

import { useApplicationContext } from '@/context/v1/Application/context';
import { EvaluatorSelect } from '@/components/ui/Inputs/EvaluatorSelect';
import { useEvaluators } from '@/hooks/v1';
import FormItem from '@/components/ui/FormItem';

const { useFormInstance, useWatch } = Form;

interface EvaluatorProps {
	onValueChange: (changed: boolean) => void;
}

export const Evaluator: React.FC<EvaluatorProps> = ({ onValueChange }) => {
	const form = useFormInstance();
	const { setFieldValue } = useFormInstance();
	const { company, organization } = useApplicationContext();

	const evaluatorId = useWatch(['evaluator_id'], form);

	const {
		data: evaluators,
		isLoading,
		isFetching,
		isError
	} = useEvaluators({
		organization_id: organization?.id,
		company_id: company?.id
	});

	function handleEvaluatorSelect(id: string) {
		setFieldValue(['evaluator_id'], id);
		onValueChange(true);
	}

	function handleClearEvaluators() {
		setFieldValue(['evaluator_id'], undefined);
	}

	return (
		<Col xs={24} sm={12}>
			<FormItem
				name={['evaluator_id']}
				label="Evaluator"
				labelCol={{ span: 24 }}
				requiredMessage="Select the evaluator"
				required
			>
				<EvaluatorSelect
					size="large"
					allowCreation={true}
					loading={isFetching}
					evaluators={evaluators}
					evaluatorId={evaluatorId}
					fieldName={['evaluator_id']}
					disabled={isLoading || isFetching || isError}
					handleSelectEvaluator={handleEvaluatorSelect}
					handleClearEvaluators={handleClearEvaluators}
				/>
			</FormItem>
		</Col>
	);
};
